/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */
import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import Theme from '../theme.js';
import invariant from 'invariant';
import Context from '../Context';
import ExecutionEnvironment from 'exenv';
import BaseReactComponent from '../components/Util/BaseReactComponent';
import getMuiTheme from 'material-ui/styles/getMuiTheme'

function baseComponent(styles) {
  return (ComposedComponent) => class BaseComponent extends BaseReactComponent {
    static childContextTypes = {
      muiTheme: React.PropTypes.object
    };

    constructor() {
      super();
      this.refCount = 0;
      ComposedComponent.prototype.renderCss = function (css) {
        let style;
        if (ExecutionEnvironment.canUseDOM) {
          if (this.styleId && (style = document.getElementById(this.styleId))) {
            if ('textContent' in style) {
              style.textContent = css;
            } else {
              style.styleSheet.cssText = css;
            }
          } else {
            this.styleId = `dynamic-css-${this.refCount++}`;
            style = document.createElement('style');
            style.setAttribute('id', this.styleId);
            style.setAttribute('type', 'text/css');

            if ('textContent' in style) {
              style.textContent = css;
            } else {
              style.styleSheet.cssText = css;
            }

            document.getElementsByTagName('head')[0].appendChild(style);
            this.refCount++;
          }
        } else {
          Context.getInstance().onInsertCss(css);
        }
      }.bind(this);

      ComposedComponent.prototype.storeSetting = function (key, value) {
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem(key, value);
        }
      };

      ComposedComponent.prototype.getSetting = function (key, defaultvalue, transform) {
        if (typeof localStorage !== 'undefined') {
          let ret = localStorage.getItem(key);
          if (ret === undefined || ret === null) {
            return defaultvalue;
          }
          if (typeof transform === 'function') {
            return transform(ret);
          }
          return ret;
        }
        return defaultvalue;
      };
    }


    componentWillMount() {
      if (ExecutionEnvironment.canUseDOM) {
        invariant(styles.use, 'The style-loader must be configured with reference-counted API.');
        styles.use();
      } else {
        Context.getInstance().onInsertCss(styles.toString());
      }
    }

    componentWillUnmount() {
      styles.unuse();
      if (this.styleId) {
        this.refCount--;
        if (this.refCount < 1) {
          let style = document.getElementById(this.styleId);
          if (style) {
            style.parentNode.removeChild(style);
          }
        }
      }
    }

    getChildContext() {
      let muitheme = getMuiTheme(Theme);
      return {
        muiTheme: muitheme
      };
    }

    shouldComponentUpdate() {
      return true;
    }

    render() {
      return <ComposedComponent {...this.props}/>
    }
  };
}

export default baseComponent;



// WEBPACK FOOTER //
// /src/decorators/baseComponent.js